import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const TitleBar = (props) => {
    const navigate = useNavigate();
    // const { data : hotel } = useSelector(state => state.hotelReducer);
    
    return (
        <div style={{ flex: 0 }}>
            <Button className={`back-button ${props.transparent ? 'back-button-transparent' : ''}`} onClick={() => {
                navigate(-1)
                // if (history.length > 1)
                //     history.goBack()
                // else
                //     history.replace(`/${hotel.code}`)
            }}><FontAwesomeIcon style={{fontSize: "18", paddingLeft: '0px', color: '#333'}} icon={faArrowLeft}/></Button>
        </div>
    )
}

TitleBar.defaultProps = {
    transparent: true
}

export default TitleBar;
